<template>
  <div class="sn-f-col-b-s depart">
    <div class="sn-f-s-0 sn-f-b-e" style="width: 100%;">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
      }]"></sn-breadcrumb>
      <div class="sn-f-e-c sn-search">
        <input placeholder="搜索医生、科室、疾病" v-model="dynamic" @keyup.enter="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : '',
          business: selectedType || perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS
        });"/>
        <div class="sn-f-c-c interaction" @click="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : '',
          business: selectedType || perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS
        });">查询</div>
      </div>
    </div>
    <div class="sn-f-s-0 sn-f-b-e sn-title operate" v-if="isHosArea">
      <div class="sn-f-s-c">
        <div class="sn-f-c-c sn-pointer title-caption"
        :class="{'interaction': area.areaId === selectedArea.areaId}" :key="area.areaId" v-for="area in areaList" @click="exchangeArea(area);">
          {{ area.areaName }}
        </div>
      </div>
    </div>
    <div class="sn-f-s-0 sn-f-b-s multiple-blank" :class="{'header': !isHosArea}">
      <div class="sn-f-1 sn-f-s-c func" v-if="functionConfig.length > 0">
        <div class="sn-f-s-0 sn-f-c-c sn-pointer func-blank" :class="{'interaction': func.type === selectedType}"
        :key="func.type" v-for="func in functionConfig" @click="exchangeType(func);">{{ func.title }}</div>
      </div>
      <div class="sn-f-s-0 sn-f-e-c filter">
        <template v-for="(item, i) in filter">
          <el-select v-if="departFilter(i).length > 1" :key="item + i" :value="item" @change="exchangeFilter($event, i);">
            <el-option :key="depart.id" :label="depart.name" :value="depart.id" v-for="depart in departFilter(i)"></el-option>
          </el-select>
        </template>
      </div>
    </div>
    <div class="sn-f-s-0 sn-f-e-c cost-blank">{{ $sn.getConfig('pcCostTitle') || '' }}</div>
    <div class="sn-f-1 sn-f-col-c-c depart-region">
      <template v-if="departInfo.length > 0">
        <div class="sn-f-s-0 sn-f-c-c depart-top">
          出诊信息
          <div class="sn-f-e-c pagination" v-if="pagination('0')">
            <div class="sn-f-c-c sn-pointer pagination-blank" v-if="pagination('1')" @click="pageCount--;">上一周</div>
            <div class="sn-f-c-c sn-pointer pagination-blank" v-if="pagination('2')" @click="pageCount++;">下一周</div>
          </div>
        </div>
        <div class="sn-f-1 depart-schedule">
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th class="name">科室</th>
                  <th class="noon">时段</th>
                  <th :class="{'sn-bc-main2': date === $sn.format.date($sn.utils.getCurrentTime(), 'yyyy-MM-dd')}" :key="i" v-for="(date, i) in tableExhibition">
                    <div>{{ $sn.format.date(new Date(date), 'MM-dd') }}</div>
                    <div>周{{ $sn.format.day(date) }}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in departExhibition">
                  <template>
                    <tr :key="item.id">
                      <td class="schedule-depart" :style="{'--left': 1}" :colspan="showScheduleDay + 2">{{ item.name }}</td>
                    </tr>
                  </template>
                  <template v-for="(element, d2) in item.children">
                    <template v-if="element.children.length > 0">
                      <tr :key="item.id + element.id">
                        <td class="schedule-depart" :style="{'--left': 2}" :colspan="showScheduleDay + 2">{{ element.name }}</td>
                      </tr>
                      <template v-for="(atomic, d3) in element.children">
                        <template v-if="atomic.children.length === 0">
                          <tr :class="{'sn-bc-background3': d3 % 2 === 1}" :key="item.id + element.id + atomic.id + noon" v-for="(noon, i) in tableInfo.noon">
                            <td class="name" v-if="i === 0" :rowspan="tableInfo.noon.length">
                              <span>{{ atomic.name }}</span><br>
                              <span class="sn-pointer sn-fc-main" v-if="login" @click="brief(atomic);">查看简介</span>
                            </td>
                            <td class="noon" :class="{'sn-bln': i !== 0}">{{ periodInfo[noon].itemName }}</td>
                            <td :key="j" v-for="(date, j) in tableExhibition">
                              <template v-if="!$sn.validate.empty($sn.format.getQuality(atomic.noonMap, noon + '.' + date))">
                                <div class="sn-f-b-c sn-f-wrap">
                                  <div class="schedule-doctor" :key="k" v-for="(schedule, k) in $sn.format.getQuality(atomic.noonMap, noon + '.' + date)">
                                    <el-popover trigger="hover" width="280" placement="right" :disabled="!login" :open-delay="100" :close-delay="0" @show="formatDoctorExpand(schedule);">
                                      <div class="doctor" v-if="doctorExpand.doctorId">
                                        <div class="sn-f-b-s">
                                          <sn-head-photo class="sn-f-s-0" :src="doctorExpand.doctorPicture" :width="60" :height="80"></sn-head-photo>
                                          <div class="sn-f-1">
                                            <div class="sn-fs-18 sn-fw-bold">{{ doctorExpand.doctorName }}</div>
                                            <div class="doctor-caption" v-if="doctorExpand.doctorTitle">职称：{{ doctorExpand.doctorTitle }}</div>
                                            <div class="doctor-caption" v-if="doctorExpand.deptName">科室：{{ doctorExpand.deptName }}</div>
                                          </div>
                                        </div>
                                        <div class="doctor-sub">医生擅长：{{ doctorExpand.doctorSkill || '暂无' }}</div>
                                      </div>
                                      <el-skeleton v-else></el-skeleton>
                                      <el-button class="sn-f-c-c interaction" slot="reference" @click="navigateUrl('/appointment/doctor', {
                                        ...schedule,
                                        areaId: selectedArea.areaId
                                      });">
                                        <template v-if="schedule.isStop === '1'">[停诊]</template>{{ schedule.doctorName }}
                                      </el-button>
                                    </el-popover>
                                  </div>
                                </div>
                              </template>
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <tr :class="{'sn-bc-background3': d2 % 2 === 1}" :key="item.id + element.id + noon" v-for="(noon, i) in tableInfo.noon">
                        <td class="name" v-if="i === 0" :rowspan="tableInfo.noon.length">
                          <span>{{ element.name }}</span><br>
                          <span class="sn-pointer sn-fc-main" v-if="login" @click="brief(element);">查看简介</span>
                        </td>
                        <td class="noon" :class="{'sn-bln': i !== 0}">{{ periodInfo[noon].itemName }}</td>
                        <td :key="j" v-for="(date, j) in tableExhibition">
                          <template v-if="!$sn.validate.empty($sn.format.getQuality(element.noonMap, noon + '.' + date))">
                            <div class="sn-f-b-c sn-f-wrap">
                              <div class="schedule-doctor" :key="k" v-for="(schedule, k) in $sn.format.getQuality(element.noonMap, noon + '.' + date)">
                                <el-popover trigger="hover" width="280" placement="right" :disabled="!login" :open-delay="100" :close-delay="0" @show="formatDoctorExpand(schedule);">
                                  <div class="doctor" v-if="doctorExpand.doctorId">
                                    <div class="sn-f-b-s">
                                      <sn-head-photo class="sn-f-s-0" :src="doctorExpand.doctorPicture" :width="60" :height="80"></sn-head-photo>
                                      <div class="sn-f-1">
                                        <div class="sn-fs-18 sn-fw-bold">{{ doctorExpand.doctorName }}</div>
                                        <div class="doctor-caption" v-if="doctorExpand.doctorTitle">职称：{{ doctorExpand.doctorTitle }}</div>
                                        <div class="doctor-caption" v-if="doctorExpand.deptName">科室：{{ doctorExpand.deptName }}</div>
                                      </div>
                                    </div>
                                    <div class="doctor-sub">医生擅长：{{ doctorExpand.doctorSkill || '暂无' }}</div>
                                  </div>
                                  <el-skeleton v-else></el-skeleton>
                                  <el-button class="sn-f-c-c interaction" slot="reference" @click="navigateUrl('/appointment/doctor', {
                                    ...schedule,
                                    areaId: selectedArea.areaId
                                  });">
                                    <template v-if="schedule.isStop === '1'">[停诊]</template>{{ schedule.doctorName }}
                                  </el-button>
                                </el-popover>
                              </div>
                            </div>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <sn-no-data message="暂无排班" v-else></sn-no-data>
    </div>
    <sn-tip-caption v-if="exhibitionTipCaption" :mode="tipCaptionMode" :title="tipCaptionTitle" :secretary="tipCaptionSecretary" @sendBack="sendBackTipCaption"></sn-tip-caption>
  </div>
</template>
<script type="text/javascript">
import { businessConfig } from '@/common/utils/function-config.js';
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger.js';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  mixins: [HomepageMixin, AppointmentMixin],
  data() {
    return {
      login: self.$sn.utils.getLoginCondition(),
      dynamic: '',
      areaList: self.$sn.utils.getHospitalAreaInformation(),
      selectedArea: {},
      selectedType: '',
      functionConfig: [],
      doctorInfo: [],
      doctorExpand: {},
      entireInfo: {},
      departInfo: [],
      tableInfo: {
        date: [],
        noon: []
      },
      pageCount: 1,
      filter: ['entire'],
      //
      showScheduleDay: self.$sn.getConfig('showScheduleDay'),
      //
      exhibitionTipCaption: false,
      tipCaptionMode: '1',
      tipCaptionTitle: '温馨提示',
      tipCaptionSecretary: ''
    };
  },
  computed: {
    pagination() {
      // 0：是否存在分页；1：上一页是否可用；2：下一页是否可用
      return (type) => {
        let verify = false;
        const date = this.tableInfo.date;
        if (date.length > 0) {
          if (type === '0') {
            if (this.$sn.format.group(date, this.showScheduleDay).length > 1) verify = true;
          }
          else if (type === '1') {
            if (this.pageCount > 1) verify = true;
          }
          else if (type === '2') {
            if (!this.$sn.validate.empty(this.$sn.format.group(date, this.showScheduleDay)[this.pageCount])) verify = true;
          }
        }
        return verify;
      };
    },
    tableExhibition() {
      let digit = [];
      if (this.tableInfo.date.length > 0) {
        digit = this.$sn.format.group(this.tableInfo.date, this.showScheduleDay)[this.pageCount - 1];
      }
      return digit;
    },
    departExhibition() {
      const basic = this.$sn.format.clone(this.departInfo);
      const handle = () => {
        const seq = (gather, ids, serial) => {
          if (serial >= ids.length) return gather;
          const match = ids[serial] === 'entire' ? gather : gather.filter(result => result.id === ids[serial]);
          return match.map(item => {
            if (item.children && item.children.length > 0) {
              return {
                ...item,
                children: seq(item.children, ids, serial + 1)
              };
            }
            return item;
          });
        };
        return seq(basic, this.filter, 0);
      };
      return handle();
    },
    departFilter() {
      return (target) => {
        const basic = this.$sn.format.clone(this.departInfo);
        const handle = () => {
          const seq = (gather, ids, serial) => {
            if (serial === target) {
              return gather;
            }
            const current = ids[serial];
            const match = gather.find(result => result.id === current);
            if (match && match.children && match.children.length > 0) {
              return seq(match.children, ids, serial + 1);
            }
            else return [];
          };
          return seq(basic, this.filter, 0);
        };
        const exhibition = [{
          id: 'entire',
          name: '全部' + this.$sn.format.nToC(target + 1) + '级科室'
        }];
        const result = handle();
        if (result.length > 0) {
          result.forEach(el => {
            exhibition.push({
              id: el.id,
              name: el.name
            });
          });
        }
        return exhibition;
      };
    }
  },
  created: async function() {
    this.$sn.assembly.loading(true);
    await this.appointment_mixin_period();
    this.$sn.assembly.loading(false);
    const secretary = this.$sn.getConfig('initialTipCaptionPattern') || this.perpetual.SECRETARY_TYPE_APPOINTMENT_NOC;
    if (this.$sn.getConfig('isShowInitialTipCaptionDepartPage') && secretary && this.$sn.utils.verifyTipCaption(secretary)) {
      this.tipCaptionMode = '1';
      this.tipCaptionTitle = '温馨提示';
      this.tipCaptionSecretary = secretary;
      this.$sn.utils.storeTipCaption(this.tipCaptionSecretary);
      this.exhibitionTipCaption = true;
    }
    this.selectedArea = this.$sn.utils.getHospitalSessionStorage('AppointmentArea') || this.areaList[0];
    this.formatFunctionConfig();
  },
  methods: {
    formatFunctionConfig() {
      this.selectedType = '';
      this.functionConfig = [];
      const business = businessConfig();
      if (!this.$sn.validate.empty(this.$sn.getConfig('typeFunctionType'))) {
        this.$sn.getConfig('typeFunctionType').forEach(type => {
          const func = this.$sn.format.clone(business).find(result => result.type === type);
          if (!this.$sn.validate.empty(func)) {
            let verify = true;
            // 综合诊疗门诊
            if (type === this.perpetual.BASIC_BUSINESS_OFFLINE_ZLYY) {
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.selectedArea.areaId === '2') {
                verify = false;
              }
            }
            // 高端医学部（VIP门诊）
            else if (type === this.perpetual.BASIC_BUSINESS_OFFLINE_GDYXB) {
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SLX) {
                verify = this.selectedArea.areaId === '1';
              }
            }
            // 肺结节多学科综合门诊/消化肿瘤多学科综合门诊
            else if ([this.perpetual.BASIC_BUSINESS_OFFLINE_FJJDXKZHMZ, this.perpetual.BASIC_BUSINESS_OFFLINE_XHZLDXKZHMZ].includes(type)) {
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SLX) {
                verify = this.selectedArea.areaId === '0';
              }
            }
            // 国际特需门诊
            else if (type === this.perpetual.BASIC_BUSINESS_OFFLINE_GJTXMZ) {
              if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.selectedArea.areaId !== '2') {
                verify = false;
              }
            }
            if (verify) {
              this.functionConfig.push(func);
            }
          }
        });
      }
      if (this.functionConfig.length > 0) {
        const storage = this.$sn.utils.getHospitalSessionStorage('AppointmentType');
        if (storage && !this.$sn.validate.empty(this.functionConfig.find(result => result.type === storage))) {
          this.selectedType = storage;
        }
        else this.selectedType = this.functionConfig[0].type;
      }
      else this.selectedType = this.perpetual.BASIC_BUSINESS_OFFLINE_CKQBYS;
      this.getDepartInfo();
    },
    exchangeArea(area) {
      this.selectedArea = area;
      this.$sn.utils.setHospitalSessionStorage('AppointmentArea', this.selectedArea);
      this.formatFunctionConfig();
    },
    exchangeType(func) {
      if (func.url) {
        this.navigateUrl(func.url, func, func.params);
        return false;
      }
      this.selectedType = func.type;
      this.$sn.utils.setHospitalSessionStorage('AppointmentType', this.selectedType);
      this.getDepartInfo();
    },
    exchangeFilter(id, serial) {
      this.filter[serial] = id;
      this.filter = this.filter.slice(0, serial + 1);
      this.filter.push('entire');
      this.$forceUpdate();
    },
    async getDepartInfo() {
      const key = this.selectedArea.areaId + '.' + this.selectedType;
      const get = () => {
        return new Promise(resolve => {
          let start = '';
          let end = '';
          if (this.$sn.getConfig('isShowTodaySchedule')) {
            if (this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'HHmmss') < this.$sn.getConfig('scheduleReleaseTime')) {
              start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd');
            }
            else {
              start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
            }
          }
          else {
            start = this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', 1, 'day');
          }
          if (this.$sn.getConfig('isObtainScheduleSendEndDate')) {
            end = this.$sn.format.date(new Date(start), 'yyyy-MM-dd', this.showScheduleDay - 1, 'day');
          }
          if (this.selectedType === this.perpetual.BASIC_BUSINESS_OFFLINE_ZKLMJZYY) end = '';
          this.$sn.utils.ordinaryRequest({
            url: Swagger.pcEntireScheduleInfoByCondition,
            query: {
              hosArea: this.selectedArea.areaId,
              hosId: this.$sn.utils.getHospitalId(),
              start: start,
              end: end,
              businessType: this.selectedType,
              empty: false
            }
          }).then(result => {
            if (result && result.code === 0 && result.data) {
              this.$sn.format.setQuality(this.entireInfo, key, result.data);
            }
            resolve();
          });
        });
      };
      this.departInfo = [];
      this.tableInfo = {
        date: [],
        noon: []
      };
      this.pageCount = 1;
      this.filter = ['entire'];
      if (this.$sn.validate.empty(this.$sn.format.getQuality(this.entireInfo, key))) {
        this.$sn.assembly.loading(true);
        await get();
        this.$sn.assembly.loading(false);
      }
      if (!this.$sn.validate.empty(this.$sn.format.getQuality(this.entireInfo, key))) {
        const entire = this.$sn.format.clone(this.$sn.format.getQuality(this.entireInfo, key));
        let date = entire.dateList;
        const noon = entire.noonList;
        const schedule = entire.scheduleList;
        if (!this.$sn.validate.empty(date)) {
          date = this.$sn.format.digitalSort(date);
          if (date.length % this.showScheduleDay !== 0) {
            const max = Math.ceil(date.length / this.showScheduleDay) * this.showScheduleDay;
            const begin = date[0];
            for (let i = 0; i < max; i++) {
              const current = this.$sn.format.date(new Date(begin), 'yyyy-MM-dd', i, 'day');
              if (!date.includes(current)) date.push(current);
            }
          }
          this.tableInfo.date = this.$sn.format.digitalSort(date);
        }
        if (!this.$sn.validate.empty(noon)) {
          this.tableInfo.noon = noon;
          this.tableInfo.noon.sort((val1, val2) => {
            if (this.periodInfo[val1].itemOrder < this.periodInfo[val2].itemOrder) return -1;
            if (this.periodInfo[val1].itemOrder > this.periodInfo[val2].itemOrder) return 1;
            return 0;
          });
        }
        if (!this.$sn.validate.empty(schedule)) {
          this.departInfo = schedule;
        }
      }
    },
    brief(depart) {
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getOfflineSingleDepartInfoByCondition,
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          hosArea: this.selectedArea.areaId,
          deptId: depart.id,
          businessType: depart.businessType
        },
        header: true
      }).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            if (result.data && result.data.deptIntroduce && this.$sn.format.html(result.data.deptIntroduce)) {
              this.tipCaptionMode = '0';
              this.tipCaptionTitle = depart.name;
              this.tipCaptionSecretary = result.data.deptIntroduce;
              this.exhibitionTipCaption = true;
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.APPOINT130,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    formatDoctorExpand(schedule) {
      this.doctorExpand = {};
      const storage = this.$sn.utils.getHospitalSessionStorage('Appointment_EntireDoctorInfo') || [];
      const match = storage.find(result => result.hosArea === this.selectedArea.areaId && result.deptId === schedule.deptId && result.doctorId === schedule.doctorId);
      if (!this.$sn.validate.empty(match)) {
        this.doctorExpand = match;
      }
      else {
        this.$sn.utils.ordinaryRequest({
          url: Swagger.getBasicDoctorInfoByCondition,
          query: {
            hosId: this.$sn.utils.getHospitalId(),
            hosArea: this.selectedArea.areaId,
            businessType: schedule.businessType,
            deptId: schedule.deptId,
            doctorId: schedule.doctorId
          },
          header: true
        }).then(result => {
          if (result && result.code === 0 && result.data && result.data.length > 0) {
            this.doctorExpand = result.data[0];
            storage.push(result.data[0]);
            this.$sn.utils.setHospitalSessionStorage('Appointment_EntireDoctorInfo', storage);
          }
        });
      }
    },
    sendBackTipCaption(type) {
      if (type) {}
      this.exhibitionTipCaption = false;
      this.tipCaptionMode = '1';
      this.tipCaptionTitle = '温馨提示';
      this.tipCaptionSecretary = '';
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.depart {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .multiple-blank {
    @include fs(14);

    overflow: hidden;
    width: calc(100% - 40px);
    border: 1px solid $border1;
    padding: 10px 10px 0;
    margin: 0 auto;

    &.header {
      margin-top: 20px;
    }

    .func {
      box-sizing: content-box;
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 10px;

      &::-webkit-scrollbar {
        display: block;
        height: 10px;

        &-track {
          background-color: $transparent;
        }

        &-thumb {
          background-color: $text6;
          border-radius: 5px;
        }
      }

      &-blank {
        box-sizing: border-box;
        height: 30px;
        color: $main;
        border: 1px solid $border1;
        border-radius: 4px;
        padding: 0 20px;
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }

        &.interaction {
          background-color: $main;
          color: $white;
          border: none;
        }
      }
    }

    .filter {
      padding-bottom: 10px;
      margin-left: 10px;

      ::v-deep .el-select {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
        }

        .el-input__inner {
          height: 30px;
        }

        .el-input__icon {
          line-height: 30px;
        }
      }
    }
  }

  .cost-blank {
    @include fs(16);

    overflow: hidden;
    width: 100%;
    color: $red1;
    padding: 10px 20px;
  }

  &-region {
    overflow: hidden;
    width: 100%;

    .depart-top {
      @include fs(20);

      width: calc(100% - 40px);
      height: 50px;
      background-color: $main;
      font-weight: bold;
      color: $white;
      position: relative;

      .pagination {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);

        &-blank {
          @include fs(16);

          font-weight: normal;
          border: 1px solid $white;
          border-radius: 4px;
          padding: 0 10px;
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .depart-schedule {
      overflow: hidden;
      width: 100%;
      padding: 0 20px 20px;

      .sn-table {
        table {
          table-layout: fixed;
        }

        thead {
          background-color: $background1;

          th {
            color: $text1;
            border-right: 1px solid $white;
            border-radius: 0;

            &:last-child {
              border-right: 1px solid $border1;
            }
          }
        }

        th,
        td {
          @include fs(14);

          height: auto;
          min-height: 30px;
          color: $text1;

          &.name {
            width: 120px;
          }

          &.noon {
            width: 60px;
          }
        }

        td {
          padding: 10px;
        }

        .schedule-depart {
          background-color: $background2;
          color: $main3;
          text-align: left;
          padding-left: calc(var(--left) * 20px);
        }

        .schedule-doctor {
          min-width: 48%;
          max-width: 96%;

          &:nth-child(2n+1) {
            margin-right: 2%;
          }

          .interaction {
            @include fs(14);

            overflow: hidden;
            width: 100%;
            background-color: $transparent;
            color: $text1;
            border: none;
            padding: 5px 0;

            &:hover {
              color: $main;
            }
          }
        }
      }
    }
  }
}
</style>
